import { useMemo } from "react";
import {
  isOverlayActive,
  sizeSelectorOverlaySchema,
} from "./size-selector-overlay-schema";
import { resolveOverlayStyling } from "./size-selector-overlay-theme";
import { SizeSelectorOverlayDialog } from "./size-selector-overlay-dialog";
import { useSizeSelectorOverlaySession } from "./use-size-selector-overlay-session";
import { useSizeFacetOptions } from "./use-size-facet-options";
import { useCookiebotSettled } from "../../../hooks/use-cookiebot-consent";

export const MmSizeSelectorOverlay = (props: Record<string, unknown>) => {
  const parsed = useMemo(() => {
    const result = sizeSelectorOverlaySchema.safeParse(props);
    return result.success ? result.data : undefined;
  }, [props]);

  const isActive = !!parsed && isOverlayActive(parsed.Active);

  // Wait until the user has responded to the Cookiebot banner so it stays
  // interactive (the overlay's modal focus trap would otherwise block it).
  const cookiebotSettled = useCookiebotSettled(isActive);

  const facetOptions = useSizeFacetOptions(
    parsed?.CategoryUri,
    isActive && cookiebotSettled,
  );

  const { isOpen, close } = useSizeSelectorOverlaySession(
    isActive && cookiebotSettled && facetOptions.status === "ready",
    parsed?._uid,
  );

  const styling = useMemo(
    () =>
      resolveOverlayStyling({
        background: parsed?.BackgroundColor,
        typography: parsed?.TypographyColor,
        ctaBackground: parsed?.ButtonColor,
        ctaText: parsed?.ButtonTextcolor,
      }),
    [
      parsed?.BackgroundColor,
      parsed?.TypographyColor,
      parsed?.ButtonColor,
      parsed?.ButtonTextcolor,
    ],
  );

  const supportingText = parsed?.SupportingText?.trim();
  const caption = parsed?.Caption?.trim();

  if (!parsed || !isActive) {
    return null;
  }

  return (
    <SizeSelectorOverlayDialog
      isOpen={isOpen}
      onClose={close}
      styling={styling}
      activeSizeChart={facetOptions.activeSizeChart}
      availableSelectors={facetOptions.availableSelectors}
      optionsByKey={facetOptions.optionsByKey}
      headline={parsed.Headline}
      supportingText={supportingText}
      caption={caption}
    />
  );
};
